export function lxkShowStreamStatus(steps, currentStepIndex) {
    const visibleSteps = steps.slice(0, currentStepIndex + 1);

    return `
        <div class="lxk-flex lxk-flex-col lxk-gap-1 lxk-w-full lxk-max-w-md">
            ${visibleSteps.map((step, index) => {
                const isCompleted = index < currentStepIndex;
                const isCurrent = index === currentStepIndex;
                
                return `
                    <div class="lxk-flex lxk-items-start lxk-gap-2 sm:lxk-gap-3 lxk-w-full lxk-ml-8">
                        <div class="lxk-flex lxk-flex-col lxk-items-center lxk-shrink-0">
                            <div class="lxk-relative">
                                <!-- Outer circle -->
                                <div class="
                                    lxk-w-3 
                                    lxk-h-3 
                                    sm:lxk-w-4 
                                    sm:lxk-h-4 
                                    lxk-rounded-full
                                    lxk-border
                                    lxk-border-lexeek-accent
                                    ${isCurrent ? 'lxk-animate-pulse' : ''}
                                "></div>
                                
                                <!-- Inner dot -->
                                <div class="
                                    lxk-absolute 
                                    lxk-top-1/2 
                                    lxk-left-1/2 
                                    -lxk-translate-x-1/2 
                                    -lxk-translate-y-1/2
                                    lxk-w-1.5
                                    lxk-h-1.5
                                    sm:lxk-w-2 
                                    sm:lxk-h-2 
                                    lxk-rounded-full
                                    lxk-bg-lexeek-accent
                                    ${isCurrent ? 'lxk-animate-pulse' : ''}
                                "></div>
                            </div>
                            
                            ${index < visibleSteps.length - 1 ? `
                                <!-- Connecting line -->
                                <div class="lxk-w-0.5 lxk-h-8 lxk-bg-lexeek-accent lxk-animate-pulse"></div>
                            ` : `
                                ${isCurrent ? `
                                    <div class="lxk-w-0.5 lxk-h-8 lxk-bg-gradient-to-b lxk-from-lexeek-accent lxk-to-transparent lxk-animate-pulse"></div>
                                ` : ''}
                            `}
                        </div>

                        <!-- Status text -->
                        <div class="
                            lxk-text-md
                            lxk-leading-tight
                            lxk-pt-0.5
                            lxk-flex-1
                            ${isCurrent ? 'lxk-animate-pulse lxk-text-lexeek-accent lxk-font-medium' : 'lxk-text-lexeek-content-alt'}
                        ">
                            ${step}
                        </div>
                    </div>
                `;
            }).join('')}
        </div>
    `;
}